import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../components/Input';
import { useAuth } from '../context/AuthContext';
import './LoginPage.css';
import logo from '../assets/bch-white.png';

function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (!username.trim() || !password) {
      setError('Please enter username and password.');
      return;
    }

    setLoading(true);
    const result = await login(username, password);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  }

  return (
    <div className="login-page">
      <div className="logo-block">
        <img src={logo} alt="Beachcomber Manager Logo" />
      </div>

      <div className="login-card">
        <h1>Sign In</h1>

        <form onSubmit={handleSubmit}>
          <div className="login-form-group">
            <Input
              label="Username"
              name="username"
              type="text"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="login-form-group">
            <Input
              label="Password"
              name="password"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {error && (
            <div className="login-error" role="alert">
              {error}
            </div>
          )}

          <button type="submit" className="login-submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div className="info-box">
          <div className="info-box-icon">
            <i className="fas fa-info"></i>
          </div>
          <div className="info-box-content">
            <strong>Authentication Required</strong>
            <span>Please use your Virmatics Platform credentials to access the system</span>
          </div>
        </div>
      </div>

      <footer className="login-footer">
        <div>© 2026 Beachcomber. All rights reserved.</div>
        <div className="footer-made-with">
            Made with <i className="fas fa-heart footer-heart"></i> by{' '}
            <a
              href="https://web.virmatics.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-virmatics-link"
            >
              Virmatics
            </a>
          </div>
      </footer>
    </div>
  );
}

export default LoginPage;
